function arrayUnique(array) {
	let a = array.concat();
	let resp = [];
	for (let i = 0; i < a.length; i++) {	
		let exists = resp.find((item)=> item.name == a[i].name);
		if(!exists){
			let to_push =a[i];
			resp.push(to_push);
		}						
	}
    return resp;
}

export {
	arrayUnique 
}

